(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    // SUPPORTING MODEL
    // This model represents a Phone Number
    function PhoneNumberViewModel() {

        // Self-Identification
        var self = this;
        self.hideDoNotContact = ko.observable(false);
        self.hideEffectiveLabelDisplay = ko.observable(false);
        sm.portal.vm.custom.setCustomLocalizeKey(self);

        this.LoadModel = function (container) {
            if (container.Payload.ListData) {
                ko.mapping.fromJS(container.Payload.ListData.PhoneTypeEntries, {}, this.TypeEntries);
                ko.mapping.fromJS(container.Payload.ListData.DoNotContactReasons, {}, this.DoNotContactReasons);
                ko.mapping.fromJS(container.Payload.ListData.AddressTimings, {}, this.AddressTimings);
                ko.mapping.fromJS(container.Payload.ListData.Carriers, {}, this.Carriers);
                ko.mapping.fromJS(container.Payload.ListData.PhoneNumberAssociations, {}, this.Associations);
            }
        }
        this.LoadPhoneModel = function (container) {

            if (!container || !container.AssociationIDs) {
                if (this.me) {
                    container = this.me;
                }
            }

            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var phoneNumberEffectiveFrom = container.EffectiveFrom ? moment(container.EffectiveFrom).format(dateFormat) : '';
            var phoneNumberEffectiveTo = container.EffectiveTo ? moment(container.EffectiveTo).format(dateFormat) : '';

            this.me = container;
            this.ID(container.ID);
            this.PhoneNumber(container.Number);
            this.Extension(container.Extension);
            this.TypeEntryID(container.TypeEntryID);
            this.EffectiveFrom(phoneNumberEffectiveFrom);
            this.EffectiveTo(phoneNumberEffectiveTo);
            this.AddressTypeID(container.AddressTypeID);
            this.AddressTimingTypeID(container.AddressTimingTypeID);
            this.DoNotContact(container.DoNotContact);
            this.NoContactReasonID(container.NoContactReasonID);
            this.CarrierID(container.PhoneCarrierID);

            this.AssociationIDs.removeAll();
            for (var i = 0; i < container.AssociationIDs.length; i++) {
                this.AssociationIDs.push(container.AssociationIDs[i].toString());
            }

            this.AssociationNames.removeAll();
            for (var i = 0; i < container.AssociationNames.length; i++) {
                this.AssociationNames.push(container.AssociationNames[i]);
            }

            this.TypeEntryName(container.TypeEntryName);
            this.AddressTypeName(container.AddressTypeName);
            this.AddressTimingTypeName(container.AddressTimingTypeName);
            this.NoContactReasonName(container.NoContactReasonName);
            this.CarrierName(container.CarrierName);            
        };

        this.ID = ko.validatedObservable();
        this.PhoneNumber = ko.validatedObservable();
        this.Extension = ko.validatedObservable();
        this.TypeEntryID = ko.validatedObservable();
        this.TypeEntryName = ko.validatedObservable();
        this.EffectiveFrom = ko.validatedObservable();
        this.EffectiveTo = ko.validatedObservable();
        this.AddressTypeID = ko.validatedObservable();
        this.AddressTypeName = ko.validatedObservable();
        this.AddressTimingTypeID = ko.validatedObservable();
        this.AddressTimingTypeName = ko.validatedObservable();
        this.DoNotContact = ko.validatedObservable();
        this.NoContactReasonID = ko.validatedObservable();
        this.NoContactReasonName = ko.validatedObservable();
        this.CarrierID = ko.validatedObservable();
        this.CarrierName = ko.validatedObservable();

        this.AssociationIDs = ko.observableArray();
        this.AssociationNames = ko.observableArray();

        this.TypeEntries = ko.observableArray([new smapi.access.ListItemModel()]);
        this.Associations = ko.observableArray([new smapi.access.ListItemModel()]);
        this.DoNotContactReasons = ko.observableArray([new smapi.access.ListItemModel()]);
        this.AddressTimings = ko.observableArray([new smapi.access.ListItemModel()]);
        this.Carriers = ko.observableArray([new smapi.access.ListItemModel()]);

        this.EffectiveLabelDisplay = ko.computed(function () {

            if (sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && !sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                return sm.portal.utility.getResourceValue('EffectiveTill');
            }
            return sm.portal.utility.getResourceValue('EffectiveFrom');

        }, this);
        this.EffectiveDisplay = ko.computed(function () {
            if (!sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && !sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                // Return full FROM..TO.. string
                return this.EffectiveFrom() + " to " + this.EffectiveTo();
            } else if (!sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                // Return FROM...
                return this.EffectiveFrom();
            } else if (sm.portal.utility.isNullOrEmpty(this.EffectiveFrom()) && !sm.portal.utility.isNullOrEmpty(this.EffectiveTo())) {
                return this.EffectiveTo();
            }
            return "";

        }, this);
        this.DoNotContactAsYesNo = ko.computed(function () {
            if (this.DoNotContact()) {
                return sm.portal.utility.getResourceValue('Yes');
            }
            return sm.portal.utility.getResourceValue('No');
        }, this);
        this.PhoneNumberDisplay = ko.computed(function () {

            if (!sm.portal.utility.isNullOrEmpty(this.PhoneNumber()) && !sm.portal.utility.isNullOrEmpty(this.Extension())) {
                return sm.portal.utility.formatString("{0} x{1}", this.PhoneNumber(), this.Extension());
            } else if (!sm.portal.utility.isNullOrEmpty(this.PhoneNumber()) && sm.portal.utility.isNullOrEmpty(this.Extension())) {
                return this.PhoneNumber();
            } else if (sm.portal.utility.isNullOrEmpty(this.PhoneNumber()) && !sm.portal.utility.isNullOrEmpty(this.Extension())) {
                return sm.portal.utility.formatString("x{0}", this.Extension());
            }
            return "";
        }, this);
        this.AssociationDisplay = ko.computed(function () {

            var display = '';
            for (var i = 0; i < this.AssociationNames().length; i++) {
                if (display == '') {
                    display = this.AssociationNames()[i];
                } else {
                    display += ', ' + this.AssociationNames()[i];
                }
            }
            return display;

        }, this);

        this.ExtractATO = function () {
            var submitPhoneObject = ko.mapping.toJS(this);
            var phoneNumberEffectiveFrom = submitPhoneObject.EffectiveFrom ? moment(submitPhoneObject.EffectiveFrom, sm.resources.portalResource.getValue('DateFormatExample').toUpperCase()).format("MM/DD/YYYY") : '';
            var phoneNumberEffectiveTo = submitPhoneObject.EffectiveTo ? moment(submitPhoneObject.EffectiveTo, sm.resources.portalResource.getValue('DateFormatExample').toUpperCase()).format("MM/DD/YYYY") : '';

            var assocIDs = Array();
            for (var i = 0; i < submitPhoneObject.AssociationIDs.length; i++) {
                assocIDs.push(submitPhoneObject.AssociationIDs[i]);
            }


            var data = {
                ID: submitPhoneObject.ID,
                Number: submitPhoneObject.PhoneNumber,
                Extension: submitPhoneObject.Extension,
                TypeEntryID: submitPhoneObject.TypeEntryID,
                EffectiveFrom: phoneNumberEffectiveFrom,
                EffectiveTo: phoneNumberEffectiveTo,
                AddressTypeID: submitPhoneObject.AddressTypeID,
                AddressTimingTypeID: submitPhoneObject.AddressTimingTypeID,
                DoNotContact: submitPhoneObject.DoNotContact,
                NoContactReasonID: submitPhoneObject.NoContactReasonID,
                PhoneCarrierID: submitPhoneObject.CarrierID,
                AssociationIDs: assocIDs
            };

            var cusData = {
                submitPhoneObject: submitPhoneObject,
                data:data
            }

            sm.portal.vm.custom.callCustomization('UpdatePhoneNoExtractATOProps', cusData);

            return data;
        };
        this.Reset = function () {
            this.ID(0);
            this.PhoneNumber('');
            this.Extension('');
            this.TypeEntryID(undefined);
            this.EffectiveFrom('');
            this.EffectiveTo('');
            this.AddressTypeID(undefined);
            this.AddressTimingTypeID(undefined);
            this.DoNotContact(false);
            this.NoContactReasonID(undefined);
            this.CarrierID(undefined);

            this.TypeEntryName('');
            this.AddressTypeName('');
            this.AddressTimingTypeName('');
            this.NoContactReasonName('');
            this.CarrierName('');
        };

        sm.portal.vm.custom.callCustomization('UpdateValidationsPhoneNo', self);
        /*** VALIDATION METHODS ***/
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PhoneNumber.extend({

            pattern: {
                // TODO needs to change via type
                params: /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '###-###-####')
            },
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.Extension.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.TypeEntryID.extend({
            min: {
                params: 1,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.EffectiveFrom.extend({
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            },
            smValidateEffectiveFromDate: {
                params: this.EffectiveTo,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_EffectiveBeginDate_Key)
            }
        });
        this.EffectiveTo.extend({
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            },
            smValidateEffectiveToDate: {
                params: this.EffectiveFrom,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_EffectiveEndDate_Key)
            }
        });
        this.AddressTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AddressTimingTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NoContactReasonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CarrierID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });

        this.ModelErrors = ko.validation.group(this);
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        /*** VALIDATION METHODS ***/

        return self;
    }

    jQuery.extend(true, sm.portal.vm, {
        PhoneNumberViewModel: PhoneNumberViewModel
    });

})(jQuery);